<div class="swiper testimonies-carousel swiper-container w-full pb-0" *ngIf="sessionResources.homeTestimonialsAndWords()?.length > 0">
  <div class="swiper-wrapper" style="padding-bottom: 0 !important;">
    <div *ngFor="let testimonialsAndWords of sessionResources.homeTestimonialsAndWords()" class="swiper-slide" [class.text-white]="!black" [class.text-theme-black]="black">
      <div class="w-full grid grid-cols-2 gap-2 p-1">
        <div *ngFor="let testimony of testimonialsAndWords.testimonials" class="w-full border-white  rounded-2xl flex flex-col " [class.border-2]="!black" [class.p-3]="!black">
          <app-stars [dark]="black"></app-stars>
          <p class="w-full font-theme-source text-sm text-left mt-2">
            {{testimony.message | limit:black ? 100 : 160}}
          </p>
          <p class="w-full font-theme-source text-sm text-right mt-2">
            <span class="font-bold">{{testimony.from}}</span><span *ngIf="!city" class="font-light">, {{testimony.city}}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="swiper-testimonies-pagination"></div>
</div>
